import React from 'react'
import { SignUpModalError as SignUpModalErrorContainer } from 'redesign/components/molecules/SignUpModalError'
import illustrationDuvidas from 'assets/illustration-unico-modal.svg'
import styled from 'styled-components'

type SignUpModalErrorProps = {
    setShowModal: (value: boolean) => void
    showModal: boolean
}
const ContainerIllustration = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    @media (max-width: 768px) {
        display: none;
    }
`

export const SignUpModalError = ({ setShowModal, showModal }: SignUpModalErrorProps) => (
    <SignUpModalErrorContainer
        setShowModal={() => {
            setShowModal(false)
        }}
        showModal={showModal}
        title={'Não foi possível confirmar sua identidade desta forma'}
    >
        <p>
            Peça ajuda da nossa <strong>central de atendimento</strong> pelo <strong>WhatsApp</strong> pra cadastrar um novo contato.
        </p>
        <br />
        <ContainerIllustration>
            <img alt="Ilustrção smartphone" src={illustrationDuvidas} />
        </ContainerIllustration>
    </SignUpModalErrorContainer>
)
